"use strict";

exports.__esModule = true;
exports.CustomDialog = void 0;
var React = _interopRequireWildcard(require("react"));
var _Modal = require("../internal/Modal");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/CustomDialog/CustomDialog.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** CustomDialog */
const CustomDialog = ({
  className,
  children,
  isOpen = false,
  onClose,
  manualFocus = false,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
  'data-hook': dataHook,
  appendToBody = false
}) => {
  return /*#__PURE__*/React.createElement(_Modal.Modal, {
    className: className,
    "data-hook": dataHook,
    isOpen: isOpen,
    focusTrap: !manualFocus,
    onRequestClose: onClose,
    appendToBody: appendToBody,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    role: "dialog",
    "aria-modal": "true",
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, children));
};
exports.CustomDialog = CustomDialog;
CustomDialog.displayName = 'CustomDialog';
//# sourceMappingURL=CustomDialog.js.map